import { useRef, ReactNode, MouseEvent, forwardRef } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  strength?: number;
  onClick?: () => void;
  as?: "button" | "div";
}

/** Button/div that gently follows the cursor within a hover radius. */
const MagneticButton = forwardRef<HTMLDivElement, Props>(function MagneticButton(
  { children, className = "", strength = 0.25, onClick, as = "button" },
  _ref,
) {
  const inner = useRef<HTMLDivElement>(null);

  const handleMove = (e: MouseEvent<HTMLDivElement>) => {
    const el = inner.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - (rect.left + rect.width / 2);
    const y = e.clientY - (rect.top + rect.height / 2);
    el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
  };

  const reset = () => {
    if (inner.current) inner.current.style.transform = "translate(0,0)";
  };

  const Wrapper: any = as;
  return (
    <Wrapper
      onMouseMove={handleMove}
      onMouseLeave={reset}
      onClick={onClick}
      className={`inline-block ${className}`}
      style={{ transition: "transform 300ms cubic-bezier(0.22,1,0.36,1)" }}
    >
      <div ref={inner} style={{ transition: "transform 250ms cubic-bezier(0.22,1,0.36,1)" }}>
        {children}
      </div>
    </Wrapper>
  );
});

export default MagneticButton;
